<template>
    <div class="p-4 w-full h-full">
        <div>
            <pre> {{defaultValue}} </pre>
            <pre> {{instructions}} </pre>
        </div>
    </div>
</template>

<script setup lang="ts">
import {ref} from 'vue'

const defaultValue = ref('DebugView.vue is created by yarn based on the DebugView.vue.example file.')
const instructions = ref('In order to stop git from deleting the DebugView.vue file when switching branches, use the command "git rm --cached pracsys-frontend/src/debug/DebugView.vue"')
</script>

<style scoped>
</style>